<div class="top-padding" *ngIf="fixedHeader" [ngClass]="{ 'd-none': isSoloMode }"></div>
<nav #navbar class="navbar page-navbar" [ngClass]="{ scrolled: isScrolled || fixedHeader, 'd-none': isSoloMode }">
  <div class="powered" [ngClass]="{ 'd-none': footerLogo }" *ngIf="!pageConfig; else partnerLogo">
    <span class="powered__label">Powered by</span>
    <a class="powered__go-button" href="/" target="_blank">WineristGO!</a>
  </div>
  <div class="navbar-right">
    <button
      class="cart"
      mat-mini-fab
      color="primary"
      [matBadge]="(cartLeght$ | async) > 0 ? (cartLeght$ | async).toString() : ''"
      matBadgeColor="warn"
      (click)="openCart()"
    >
      <mat-icon aria-label="Shopping cart">shopping_cart</mat-icon>
    </button>

    <mat-form-field *ngIf="isMultilanguage">
      <mat-select [value]="selectedContentLanguage" (selectionChange)="setContentLanguage($event.value)">
        <mat-option *ngFor="let language of Language | keyvalue" [value]="language.value" class="small-option">
          <div class="language-content-text">{{ language.key }}</div>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</nav>

<ng-template #partnerLogo>
  <a
    [href]="pageConfig.bookingWidgetUrl ? 'http://' + pageConfig.bookingWidgetUrl + '/' : '#'"
    class="partner-logo"
    [ngStyle]="{ 'background-image': 'url(' + pageConfig?.logoUrl + ')' }"
  >
  </a>
</ng-template>
